import { render, staticRenderFns } from "./XrImport.vue?vue&type=template&id=bec0ead6&scoped=true"
import script from "./XrImport.vue?vue&type=script&lang=js"
export * from "./XrImport.vue?vue&type=script&lang=js"
import style0 from "./XrImport.vue?vue&type=style&index=0&id=bec0ead6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec0ead6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec0ead6')) {
      api.createRecord('bec0ead6', component.options)
    } else {
      api.reload('bec0ead6', component.options)
    }
    module.hot.accept("./XrImport.vue?vue&type=template&id=bec0ead6&scoped=true", function () {
      api.rerender('bec0ead6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WkImport/XrImport.vue"
export default component.exports